/**
 * For foreign exchange Quanto option feature.
 * tag: 2126
 * @readonly
 * @enum {number} (int)
 */
export enum ComplexEventQuoteBasis {
  /** Currency 1 per currency 2 */
  Currency1PerCurrency2 = 0,
  /** Currency 2 per currency 1 */
  Currency2PerCurrency1 = 1,
}
